/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import './component011.less';

interface IComponent011Item {
  name: string;
  desc: string;
  img: string;
  width: string;
}

interface IComponent011Props {
  title: string;
  content: string;
  items: IComponent011Item[];
  className: string;
}

const Component011: React.FunctionComponent<IComponent011Props> = ({
  title,
  content,
  items,
  className,
}) => {
  const getImg = (img: string) =>
    require(`../../../../../assets/${img}`).default;
  return (
    <div className={`social-attack-section component ${className}`}>
      <div className="title">
        <div className="l1" dangerouslySetInnerHTML={{ __html: title }} />
      </div>
      <p className="content" dangerouslySetInnerHTML={{ __html: content }} />
      <div className="cyber-phishing-section">
        {items.map((itm: any, idx: number) => (
          <div key={idx} className="cyber-phishing-item">
            <div className="cyber-phishing-icon">
              <img src={getImg(itm.img)} alt="" width={itm.width} />
            </div>
            <div className="name">{itm.name}</div>
            <div className="desc">{itm.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Component011;
